export const getLine3Nodes = (
  searchParams,
  initialNodesData,
  line3Conditions
) => {
  const line3Nodes = [];

  line3Conditions.forEach(({ param, code }) => {
    const condition = searchParams.get(param);
    if (condition === "t") {
      const node = initialNodesData.find((n) => n.id === code && n.line === 0);
      if (node) {
        line3Nodes.push(node);
      }
    }
  });

  return line3Nodes;
};
